import type { HTMLAttributes } from 'react';
import React from 'react';
import classNames from 'classnames';
import { useAppContext } from '$util/AppContext';
import { Icon } from '@/components/atoms/Icon';
import styles from './index.module.scss';

interface PromotionBannerProps extends HTMLAttributes<HTMLDivElement> {
  readonly addon?: React.ReactNode;
}

/**
 * @deprecated use src/components/molecules/TopNavBanner
 */
export function PromotionBanner({ addon, className, ...props }: PromotionBannerProps): JSX.Element | null {
  const AppContext = useAppContext();
  const { campaign } = AppContext;

  if (!campaign) return null;

  const { name: campaignName } = campaign || {};

  return (
    <div {...props} className={classNames(PromotionBanner.displayName, className, styles.PromotionBanner)}>
      <div className={styles['discount-wrapper']}>
        <Icon className={styles['sale-icon']} id="finance/tag-01-flipped" legacy={false} />
        <span className={styles.discount}>{campaignName}</span>
      </div>
      {addon}
    </div>
  );
}

PromotionBanner.displayName = 'PromotionBanner';
